import { Box } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ActionBanner } from "../../../common/components/functional/actionBanner/ActionBanner";
import { RoundedButton } from "../../../common/components/styled/styled";
import { ReactComponent as CheckmarkIcon } from "../../../common/icons/check.svg";
import { ReactComponent as EditIcon } from "../../../common/icons/edit.svg";
import { AccessRightContext } from "../../user/AccessRightProvider";
import { JobAdStatus } from "../types/common";
import { useFormContext } from "react-hook-form";

type Props = {
  handleSave: () => void;
  jobAdStatus: JobAdStatus | undefined;
  onPublishButtonClick: () => void;
  isEditing: boolean;
  setIsEditing: (val: boolean) => void;
  hasUnsavedChanges: boolean;
  isValid: boolean;
  dateRangeIsValid: boolean;
};

const JobAdFormActionBanner = ({
  handleSave,
  onPublishButtonClick,
  isEditing,
  setIsEditing,
  jobAdStatus,
  hasUnsavedChanges,
  isValid,
  dateRangeIsValid,
}: Props) => {
  const { t } = useTranslation();

  // Get trigger for hook form
  const { trigger } = useFormContext();

  const { canWriteJobAd } = useContext(AccessRightContext);

  if (!canWriteJobAd) return null;

  const handleSaveWithValidation = async () => {
    const isFormValid = await trigger();
    if (isFormValid) {
      handleSave();
    }
  };

  return (
    <ActionBanner isOpen={true}>
      <Box display="flex" justifyContent={"end"} width={"100%"}>
        {isEditing && (
          <Box
            onClick={handleSaveWithValidation}
            style={{
              cursor: "pointer",
              pointerEvents: isValid ? "auto" : "all",
            }}
          >
            <RoundedButton
              variant="contained"
              disabled={!isValid}
              style={{
                opacity: isValid ? 1 : 0.5,
                pointerEvents: "none",
              }}
            >
              <CheckmarkIcon
                style={{
                  marginRight: "8px",
                }}
              />
              {t("save")}
            </RoundedButton>
          </Box>
        )}
        {!isEditing && jobAdStatus !== JobAdStatus.CLOSED && (
          <RoundedButton variant="outlined" onClick={() => setIsEditing(true)}>
            <EditIcon style={{ marginRight: "8px" }} />
            {t("edit")}
          </RoundedButton>
        )}
        {jobAdStatus === JobAdStatus.DRAFT && (
          <RoundedButton
            variant="contained"
            disabled={isEditing || !dateRangeIsValid}
            onClick={onPublishButtonClick}
            sx={{ marginLeft: "16px" }}
          >
            <EditIcon style={{ marginRight: "8px" }} />
            {t("jobAds:publishJobAd")}
          </RoundedButton>
        )}
      </Box>
    </ActionBanner>
  );
};

export default JobAdFormActionBanner;
